import { render, staticRenderFns } from "./soNoRender.vue?vue&type=template&id=25ce8fb8&scoped=true&"
import script from "./soNoRender.vue?vue&type=script&lang=js&"
export * from "./soNoRender.vue?vue&type=script&lang=js&"
import style0 from "./soNoRender.vue?vue&type=style&index=0&id=25ce8fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ce8fb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25ce8fb8')) {
      api.createRecord('25ce8fb8', component.options)
    } else {
      api.reload('25ce8fb8', component.options)
    }
    module.hot.accept("./soNoRender.vue?vue&type=template&id=25ce8fb8&scoped=true&", function () {
      api.rerender('25ce8fb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/soNoRender.vue"
export default component.exports